var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-button",
    {
      directives: [
        {
          name: "touch",
          rawName: "v-touch:tap",
          value: () => _vm.toggleQuestion(),
          expression: "() => toggleQuestion()",
          arg: "tap",
        },
      ],
      staticClass: "result__cta__button",
      class: { "result__cta__button--unrolled": _vm.isQuestionOpen },
      attrs: { isResult: true },
    },
    [
      _c("span", { staticClass: "result__cta__title" }, [
        _c("span", { staticClass: "picto_line__text" }, [
          _vm._v(" " + _vm._s(_vm.$t("result.question")) + " "),
        ]),
        _c("span", { staticClass: "picto_line__picto" }, [
          _c("img", {
            staticClass: "result__cta__arrow",
            attrs: {
              "svg-inline": "",
              src: require("@/assets/icons/arrow-down.svg"),
            },
          }),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "unroll",
          class: { "unroll--unrolled": _vm.isQuestionOpen },
        },
        [
          _c(
            "a",
            {
              staticClass: "unroll__link",
              attrs: { href: "tel:+33144542083" },
            },
            [
              _c("span", { staticClass: "picto_line__text" }, [_vm._v("call")]),
              _c("span", { staticClass: "picto_line__picto" }, [
                _c("img", {
                  attrs: {
                    "svg-inline": "",
                    src: require("@/assets/icons/phone.svg"),
                  },
                }),
              ]),
            ]
          ),
          _c(
            "a",
            {
              staticClass: "unroll__link",
              attrs: { href: "mailto:contact@buly1803.com" },
            },
            [
              _c("span", { staticClass: "picto_line__text" }, [
                _vm._v("email"),
              ]),
              _c("span", { staticClass: "picto_line__picto" }, [
                _c("img", {
                  attrs: {
                    "svg-inline": "",
                    src: require("@/assets/icons/email.svg"),
                  },
                }),
              ]),
            ]
          ),
          _vm.isMobile
            ? _c(
                "a",
                {
                  staticClass: "unroll__link",
                  attrs: { href: "https://wa.me/33648006989?text=" },
                },
                [
                  _c("span", { staticClass: "picto_line__text" }, [
                    _vm._v("whatsapp"),
                  ]),
                  _c("span", { staticClass: "picto_line__picto" }, [
                    _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: require("@/assets/icons/whatsapp.svg"),
                      },
                    }),
                  ]),
                ]
              )
            : _c(
                "a",
                {
                  staticClass: "unroll__link",
                  attrs: {
                    href: "https://web.whatsapp.com/send?l=fr&phone=33648006989&text=",
                  },
                },
                [
                  _c("span", { staticClass: "picto_line__text" }, [
                    _vm._v("whatsapp"),
                  ]),
                  _c("span", { staticClass: "picto_line__picto" }, [
                    _c("img", {
                      attrs: {
                        "svg-inline": "",
                        src: require("@/assets/icons/whatsapp.svg"),
                      },
                    }),
                  ]),
                ]
              ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }